var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDialogHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9769 13.7249C34.9769 6.18238 28.298 0 20 0C11.7695 0 5.02314 6.12056 5.02314 13.7249C5.02314 13.7249 4.3485 18.4853 10.2853 26.2133C12.9838 29.6754 20 40 20 40C20 40 27.0837 29.6754 29.7147 26.2133C35.6515 18.4853 34.9769 13.7249 34.9769 13.7249ZM20 21.0819C15.6823 21.0819 12.2417 17.8671 12.2417 13.9722C12.2417 10.0155 15.7498 6.80062 20 6.80062C24.3177 6.80062 27.8258 10.0155 27.8258 13.9722C27.8258 17.8671 24.3177 21.0819 20 21.0819Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogHeader);
export default __webpack_public_path__ + "static/media/dialogHeader.29eb6b71717ff9bb8324a71aa4253485.svg";
export { ForwardRef as ReactComponent };